import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";
import { parseNewsletterSearch } from "./lib/newsletterSearch";

const newsletter = lazyWithRetry(() => import("./routes/newsletter"));

const newsletterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/marketing/newsletter",
  validateSearch: parseNewsletterSearch,
  component: () =>
    renderProtectedRoute(newsletter, {
      requirePerms: ["marketing:read"],
    }),
});

export const marketingRouteTree = [newsletterRoute];
